import { Typography } from "@mui/material";
import Lottie from "lottie-react";



interface LottieLoadingProps
{
  animation: string;
  loop: boolean;
  width: number;
  height: number;
  text: string;
  containerHeight?: string
}

export const LottieLoading = ({ animation, loop, width, height, text, containerHeight }: LottieLoadingProps) =>
{
  return(
    <div style={{ ...styles.container, height: containerHeight || "90vh"}}>
      <Lottie animationData={animation} loop={loop} style={{ width, height }} />
      <Typography variant="subtitle1" fontWeight={700} color='textSecondary'>{text}</Typography>
    </div>
  )
}

const styles = {
  container: {
    flex: 1,
    display: 'flex' as 'flex',
    alignItems: 'center' as 'center',
    justifyContent: 'center' as 'center',
    flexDirection: 'column' as 'column'
  }
}